<template>
  <div class="rate-card">
    <div class="rate-card__glow"></div>
    <div class="rate-card__inner">
      <div class="rate-card__header">
        <div class="rate-card__title-wrap">
          <i class="bi bi-currency-exchange rate-card__header-icon"></i>
          <span class="rate-card__title">Valyuta məzənnələri</span>
        </div>
        <div class="rate-card__live-badge">
          <span class="rate-card__pulse-dot"></span>
          <span class="rate-card__bank-label">MB AZN</span>
        </div>
      </div>

      <div class="rate-card__currencies">
        <div class="rate-card__item rate-card__item--usd">
          <div class="rate-card__item-symbol">$</div>
          <div class="rate-card__item-info">
            <span class="rate-card__item-code">USD</span>
            <span class="rate-card__item-rate">{{ usdRate }}</span>
          </div>
        </div>

        <div class="rate-card__divider"></div>

        <div class="rate-card__item rate-card__item--eur">
          <div class="rate-card__item-symbol">€</div>
          <div class="rate-card__item-info">
            <span class="rate-card__item-code">EUR</span>
            <span class="rate-card__item-rate">{{ eurRate }}</span>
          </div>
        </div>

        <div class="rate-card__divider"></div>

        <div class="rate-card__item rate-card__item--yen">
          <div class="rate-card__item-symbol">¥</div>
          <div class="rate-card__item-info">
            <span class="rate-card__item-code">JPY</span>
            <span class="rate-card__item-rate">{{ yenRate }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MiniRateCard",
  props: {
    usd: {
      type: [Number, String],
      default: 1.70,
    },
    eur: {
      type: [Number, String],
      default: 1.84,
    },
    yen: {
      type: [Number, String],
      default: 0.011,
    },
  },
  computed: {
    usdRate() {
      if (typeof this.usd === "number") {
        return this.usd.toFixed(2);
      }
      return this.usd;
    },
    eurRate() {
      if (typeof this.eur === "number") {
        return this.eur.toFixed(2);
      }
      return this.eur;
    },
    yenRate() {
      if (typeof this.yen === "number") {
        return this.yen.toFixed(3);
      }
      return this.yen;
    },
  },
};
</script>

<style scoped lang="scss">
.rate-card {
  position: relative;
  border-radius: 12px;
  overflow: hidden;
  height: 100%;
  min-height: 68px;
  background: var(--app-surface-elevated, #1c232b);
  border: 1px solid var(--app-border, rgba(255, 255, 255, 0.08));
  box-shadow: 0 4px 14px -2px rgba(0, 0, 0, 0.15);
  transition: all 0.28s cubic-bezier(0.4, 0, 0.2, 1);
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    transform: translateY(-2px);
    border-color: rgba(56, 189, 248, 0.4);
    box-shadow: 0 8px 20px -4px rgba(56, 189, 248, 0.2), 0 2px 8px rgba(0, 0, 0, 0.1);
  }
}

.rate-card__glow {
  position: absolute;
  top: -20px;
  right: -20px;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #38bdf8;
  opacity: 0.12;
  filter: blur(24px);
  pointer-events: none;
  transition: opacity 0.3s ease;
}

.rate-card:hover .rate-card__glow {
  opacity: 0.24;
}

.rate-card__inner {
  position: relative;
  z-index: 1;
  padding: 8px 12px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 4px;
}

.rate-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.rate-card__title-wrap {
  display: flex;
  align-items: center;
  gap: 5px;
}

.rate-card__header-icon {
  font-size: 12.5px;
  color: #38bdf8;
}

.rate-card__title {
  font-size: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: var(--app-text, #94a3b8);
}

.rate-card__live-badge {
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 1px 6px;
  border-radius: 5px;
  background: rgba(16, 185, 129, 0.12);
  border: 1px solid rgba(16, 185, 129, 0.25);
}

.rate-card__pulse-dot {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #10b981;
  box-shadow: 0 0 6px #10b981;
  animation: pulse-glow 2s infinite ease-in-out;
}

@keyframes pulse-glow {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.4;
    transform: scale(0.85);
  }
}

.rate-card__bank-label {
  font-size: 9px;
  font-weight: 700;
  color: #34d399;
  letter-spacing: 0.2px;
}

.rate-card__currencies {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: rgba(0, 0, 0, 0.18);
  border-radius: 8px;
  padding: 3px 8px;
  border: 1px solid rgba(255, 255, 255, 0.05);
}

.rate-card__item {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1;
  justify-content: center;
  padding: 2px 4px;
  border-radius: 6px;
  transition: background 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.05);
  }
}

.rate-card__item-symbol {
  width: 22px;
  height: 22px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  flex-shrink: 0;
}

.rate-card__item--usd .rate-card__item-symbol {
  background: rgba(16, 185, 129, 0.16);
  color: #34d399;
  border: 1px solid rgba(16, 185, 129, 0.3);
}

.rate-card__item--eur .rate-card__item-symbol {
  background: rgba(99, 102, 241, 0.16);
  color: #818cf8;
  border: 1px solid rgba(99, 102, 241, 0.3);
}

.rate-card__item--yen .rate-card__item-symbol {
  background: rgba(245, 158, 11, 0.16);
  color: #fbbf24;
  border: 1px solid rgba(245, 158, 11, 0.3);
}

.rate-card__item-info {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
}

.rate-card__item-code {
  font-size: 9px;
  font-weight: 700;
  color: var(--app-text, #94a3b8);
  letter-spacing: 0.3px;
}

.rate-card__item-rate {
  font-size: 14px;
  font-weight: 800;
  color: var(--app-heading, #f1f5f9);
  font-variant-numeric: tabular-nums;
}

.rate-card__divider {
  width: 1px;
  height: 18px;
  background: var(--app-border, rgba(255, 255, 255, 0.08));
  margin: 0 3px;
}

/* Light mode adjustments */
html[data-theme="light"] .rate-card {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  .rate-card__title {
    color: #64748b;
  }

  .rate-card__currencies {
    background: #f8fafc;
    border-color: #e2e8f0;
  }

  .rate-card__item-code {
    color: #64748b;
  }

  .rate-card__item-rate {
    color: #0f172a;
  }

  .rate-card__divider {
    background: #e2e8f0;
  }
}
</style>
